import VacationIcon from "@mui/icons-material/BeachAccess";
import { useVacationDaysFormat } from "~components/shared/useVacationDaysFormat.ts";
import { useCurrentEmployee } from "~contexts/CurrentEmployeeContext/CurrentEmployeeContext.tsx";
import { useTranslation } from "~contexts/I18nContext/I18nContext";
import type { VacationEntitlement } from "~generated";
import { TimeCard } from "./TimeCard";

export type VacationEntitlementCardProps = {
  vacation: VacationEntitlement;
};

export function VacationEntitlementCard({
  vacation,
}: VacationEntitlementCardProps) {
  const t = useTranslation();
  const { currentEmployee } = useCurrentEmployee();
  const vacationDays = useVacationDaysFormat();

  return (
    <TimeCard
      variant={{ name: "desktop", icon: VacationIcon }}
      label={t.vacationEntitlement}
      caption={`${t.vacationEntitlementInclCarryover}: ${vacationDays.format(vacation.entitlement_days)}`}
      items={[
        {
          label: t.vacationEntitlementTaken,
          ...vacationDays.parts(vacation.used_days),
          tooltip: currentEmployee.is_white_collar_worker
            ? t.vacationEntitlementTakenTooltip
            : undefined,
        },
        {
          label: t.vacationEntitlementPlanned,
          ...vacationDays.parts(vacation.planned_days),
          tooltip: t.vacationEntitlementPlannedTooltip,
        },
        {
          label: t.vacationEntitlementRemaining,
          ...vacationDays.parts(vacation.remaining_days),
        },
      ]}
    />
  );
}
